// 登录
export const loginUrl = () => `/app/account/login`
// 注册
export const registerUrl = () => `/app/account/register`
// 主账号注册
export const registerServerUserUrl = () =>
  `/app/serveice-group/regist-service-user`
// 子账号注册前查询服务代码
export const serverCodeByInviteUrl = () =>
  `/app/serveice-group/code-by-invite-code`
// 子账号注册
export const inviteRegisterUrl = () => `/app/serveice-group/invita-register`
// 修改密码
export const upDataAccountChangePassword = () => '/app/account/change-password'

// 文件上传下载
export const fileUploadToServer = (path: string) => `/Files/create?path=${path}`
export const fileDownFromServer = (id: string) => `/Files/download?id=${id}`
export const viewFile = (id: string) => `/Files/view?id=${id}`
